import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { Markdown } from '@applyboard/crystal-ui';
import { RawHtml } from "../../../../components/RawHtml";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function RequirementDescription(_ref) {
  var description = _ref.description,
    requirementType = _ref.requirementType,
    truncationSettings = _ref.truncationSettings,
    baseHeadingLevel = _ref.baseHeadingLevel;
  if (requirementType === 'hybrid') return _jsx(Markdown, {
    markdown: description,
    headingSettings: {
      baseLevel: baseHeadingLevel
    },
    truncationSettings: truncationSettings
  });
  return _jsx(RawHtml, {
    dangerouslySetInnerHTML: {
      __html: description
    },
    truncationSettings: truncationSettings
  });
}